/* eslint-disable */
import { MenuItem, Select } from "@mui/material";

const CustomReportSelect2 = ({name, id, list, onChange, labelName, isLabelView=false, ...restProps}) => {

    return (
        <Select
            {...restProps}
            sx={{
                backgroundColor: "inherit",
                "& .MuiOutlinedInput-notchedOutline>legend":{overflow:"unset"},
                "& .MuiOutlinedInput-notchedOutline>legend>span":{opacity:"unset", color:"#fff",backgroundColor:"gray",borderRadius:"5px",position:"relative",top:"-5px"}
            }}
            onChange={onChange}
        >
            <MenuItem 
            sx={{display : `${isLabelView?'':'none'}`}}
            key="empty"
            value={''}>
                {labelName}
            </MenuItem>
            {list && list.map((opt) => (
            <MenuItem key={opt.id} value={opt.id+','+opt.name}>
                {opt.name}
            </MenuItem> 
            ))}
        </Select>
    );
};

export default CustomReportSelect2;